import { render, staticRenderFns } from "./sku-form.vue?vue&type=template&id=ed3a980c&scoped=true"
import script from "./sku-form.vue?vue&type=script&lang=js"
export * from "./sku-form.vue?vue&type=script&lang=js"
import style0 from "./sku-form.vue?vue&type=style&index=0&id=ed3a980c&prod&lang=scss&scoped=true"
import style1 from "./sku-form.vue?vue&type=style&index=1&id=ed3a980c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3a980c",
  null
  
)

export default component.exports